import type { KeycloakLike } from './keycloak';

export interface AuthProviderProps {
  keycloak: KeycloakLike;
  children: React.ReactNode;
}

export interface AuthProviderState {
  isInitialized: boolean;
}

export enum Role {
  APPROVER = 'APPROVER',
  PGROLE = 'PGROLE',
  EQUIPMENT_MOBILE = 'EQUIPMENT_MOBILE',
  EQUIPMENT_STATIONARY = 'EQUIPMENT_STATIONARY',
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL',
  BETA_TESTER = 'BETA_TESTER',
}

export enum UserRole {
  APPROVER = 'approver',
  PGROLE = 'performance-guarantee-approver',
  EQUIPMENT_MOBILE = 'equipment-mobile',
  EQUIPMENT_STATIONARY = 'equipment-stationary',
  EXTERNAL = 'external',
  INTERNAL = 'internal',
  BETA_TESTER = 'beta-features',
}
